/*
  电子合同接口连接： https://confluence.gyasset.com/pages/viewpage.action?pageId=90189027
 */

import { concatUrl } from './base'
import { appRequest } from './request'

/*
  查询预约订单步骤 /econtract/querySteps
  {
    // 0认购 1申购 2追加 3赎回
    "apply_type": "0",
    "fund_id": "04678733b877a44d27d32f92a040c921",
    "apply_id":
  }
 */
  export async function querySteps (params) {
    const data = await appRequest(concatUrl('/econtract/querySteps'), {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {'Content-Type': 'application/json'}
    })
    return data
  }

/*
校验产品在妥妥递的状态
 */
export async function checkTtdFundStatus (params) {
  const data = await appRequest(concatUrl('/econtract/checkTtdFundStatus'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

/*
  人脸验证 /econtract/clientAuthFace 
  {
    "auth_result": 1 // 1：认证通过 0：认证不通过
}
 */
export async function clientAuthFace (params) {
  const data = await appRequest(concatUrl('/econtract/clientAuthFace'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}
/*
  查询协议 /econtract/agreement
  {
    "type": 3   // 3人脸识别服务协议 4CFCA数字证书服务合同（RA、无纸化版）5 银行卡协议
  }
 */
export async function agreement (params) {
  const data = await appRequest(concatUrl('/econtract/agreement'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}
/*
  银行卡认证时候的校验姓名和证件号是否和系统中一致 /econtract/bankCheckClientInfo
  {
    "customer_name": "双录专业投资者",
    "id_no": "4201021995101221119"
  }
 */
export async function bankCheckClientInfo (params) {
  const data = await appRequest(concatUrl('/econtract/bankCheckClientInfo'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 银行卡认证预校验
export async function clientAuthBankPreCheck () {
  const data = await appRequest(concatUrl('/econtract/clientAuthBankPreCheck'), {
    method: 'POST',
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 五要素发送验证短信
export async function authBankIdentity (params) {
  const data = await appRequest(concatUrl('/econtract/authBankIdentity'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}


/**
 *  银行卡认证 /econtract/clientAuthBank
 *  params: {
      // 用户名
      "customer_ame": "",
      // 证件号
      "id_no": "",
      // 证件类型
      "id_type": "",
      // 银行卡号
      "bank_num": "",
      // 手机号
      "mobile": "",
      // 验证码
      "captcha_code": ""
    }
 */
export async function clientAuthBank (params) {
  const data = await appRequest(concatUrl('/econtract/clientAuthBank'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

/**
 *  银行卡认证 /econtract/setSignImage
 * form-data入参  file签名图片
 */
export async function setSignImage ({file, applyId}) {
  const body = new FormData()
  body.append('file', file)
  body.append('applyId', applyId)

  const data = await appRequest(concatUrl('/econtract/setSignImage'), {
    method: 'POST',
    body,
  })
  return data
}

// 签名图片重新上传
export async function updateSignImage ({ file, check_code, type }) {
  const body = new FormData()
  body.append('file', file)
  body.append('check_code', check_code)
  body.append('type', type)

  const data = await appRequest(concatUrl('/econtract/updateSignImage'), {
    method: 'POST',
    body,
  })
  return data
}
/**
 *   设置密码 /econtract/setSignPassword
 * {
    // 密码
    "sign_password": "",
    // 交易id
    "apply_id": ""
}
 */
export async function setSignPassword (params) {
  const data = await appRequest(concatUrl('/econtract/setSignPassword'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}
/**
 *    签署电子签名承诺函 /econtract/signElectronLetter
 * {
    "sign_password": "e10adc3949ba59abbe56e057f20f883e"
}
 */
export async function signElectronLetter (params) {
  const data = await appRequest(concatUrl('/econtract/signElectronLetter'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 签署适当性文件
export async function signAppropriateFile (params) {
  const data = await appRequest(concatUrl('/econtract/signAppropriateFile'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// GET 获取用户的签名图片 /econtract/getSignPicture  返回流
export async function getSignPicture () {
  const url = concatUrl('/econtract/getSignPicture')
  // console.log('-------res', url)
  // const result = await appRequest(concatUrl('/econtract/getSignPicture'), {
  //   method: 'GET',
  //   responseType: 'blob'
  // })
  return url
}

/**
 *    重置密码 /econtract/resetPassword
{
    // 密码
    "sign_password": "",
    // 确认密码
    confirm_password: ""
}
 */
// 后期重新做的时候注意入参的mobile可以不需要
export async function resetPassword (params) {
  const data = await appRequest(concatUrl('/econtract/resetPassword'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}
    
/**
 *    上传资质证明文件 /econtract/uploadCertificateFile
form-data形式
identity_files 身份证件文件 数组
asset_files 金融资产证明文件或收入证明 数组
investment_files 投资经历、工作经历或职业资格证明 数组
apply_id 交易id
delete_files 删除文件
 */
export async function uploadCertificateFile (params) {
  console.log(params, 'param1s=================')
  const body = new FormData()
  Object.keys(params).forEach((key) => {
    if (['identity_files', 'asset_files', 'investment_files'].includes(key)) {
      (params[key] || []).forEach((file) => {
        body.append(key, file)
      })
    } else {
      body.append(key, params[key]);
    }
  })
  // idCardFiles.forEach((item) => {
  //   body.append('idCardFiles', item.file)
  // })
  // assetFiles.forEach((item) => {
  //   body.append('assetFiles', item.file)
  // })
  // body.append('applyId', applyId)

  const data = await appRequest(concatUrl('/econtract/uploadCertificateFile'), {
    method: 'POST',
    body,
  })
  return data
}

// 获取上次上传的证明文件
// apply_id 交易id
export async function obtainLatestCertificate (params) {
  const data = await appRequest(concatUrl('/econtract/obtainLatestCertificate'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

export function previewIdentityImage (id) {
  return concatUrl(`/econtract/previewIdentityImage/${id}`)
}

/**
 *    查询签署页面适当性文件 /econtract/appropriateSignFile
 */
export async function appropriateSignFile (params) {
  const data = await appRequest(concatUrl('/econtract/appropriateSignFile'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}
/**
 *    确认适当性文件 /econtract/confirmAppropriateFile
 * {
    "apply_id": 14263,
    // 资产证件文件 -1:没有该项 0:未上传 1:已上传
    "upload_certification_state": -1,
    // 是否确认证明文件 -1：无需确认 0：未确认 1：已确认
    "certification_confirm": -1,
    // 投资者基本信息表 -1:没有该项 0:未确认 1:已确认
    "basic_info_confirm": -1,
    // 风险评估问卷 -1:没有该项 0:未确认 1:已确认
    "risk_confirm": -1,
    // 风险匹配确认函 -1:没有该项 0:未确认 1:已确认
    "risk_match_confirm": -1,
    // 调整函 -1:没有该项 0:未确认 1:已确认
    "adjustment_confirm": -1
}
 */
export async function confirmAppropriateFile (params) {

  const data = await appRequest(concatUrl('/econtract/confirmAppropriateFile'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

/* 
获取签署合同的信息 /econtract/signContractInfo
{
    "apply_id": ""
}
*/
export async function signContractInfo (params) {

  const data = await appRequest(concatUrl('/econtract/signContractInfo'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}
/* 
完成签署合同 /econtract/finishSignContract
{
    "apply_id": ""
}
*/
export async function finishSignContract (params) {

  const data = await appRequest(concatUrl('/econtract/finishSignContract'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

//  获取认申购文件列表 
export async function subscriptionReviewFile (params) {

  const data = await appRequest(concatUrl('/econtract/subscriptionReviewFile'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}


//  获取待打款募集账户信息  
export async function paymentInfo (params) {

  const data = await appRequest(concatUrl('/econtract/paymentInfo'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

//  回访确认 
export async function returnVisitConfirm (params) {

  const data = await appRequest(concatUrl('/econtract/returnVisitConfirm'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

//  获取回访确认页信息 
export async function returnVisitInfo (params) {

  const data = await appRequest(concatUrl('/econtract/returnVisitInfo'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

//  获取回访确认页信息 
export async function econtractShowPrepare (params) {

  const data = await appRequest(concatUrl('/econtract/showPrepare'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}


// 记录勾选协议 
export async function agreementCheckLog (params) {

  const data = await appRequest(concatUrl('/econtract/agreementCheckLog'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 获取妥妥递的appId 
export async function encodeStr () {
  const data = await appRequest(concatUrl('/econtract/encodeStr'), {
    method: 'POST',
    // body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}


// 获取文件流查看pdfjs
export async function previewPdf (params) {
  const url = concatUrl(`/filePreview/previewPdf`)
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
  })
  const blob = await response.blob();
  return blob
}

// 获取文件流查看pdfjs
export async function getPdfPage (params) {
  const data = await appRequest(concatUrl('/filePreview/getPdfPage'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 修改签署密码-密码验证
export async function verifySignPassword (params) {
  const data = await appRequest(concatUrl('/econtract/verifySignPassword'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 修改签署密码-修改密码
export async function modifyPassword (params) {
  const data = await appRequest(concatUrl('/econtract/modifyPassword'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 修改投资者基本信息表
export async function updateUserInfo (params) {
  const data = await appRequest(concatUrl('/econtract/updateUserInfo'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}

// 校验管理端是否正在上传
export async function checkUploadStatus (params) {
  const data = await appRequest(concatUrl('/econtract/checkUploadStatus'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {'Content-Type': 'application/json'}
  })
  return data
}